"use client";

import { ApiCatalog } from "@/api/catalog";
import { useQuery } from "@tanstack/react-query";
import { notFound, useParams } from "next/navigation";

export const useProductData = () => {
  const params = useParams();
  const { id } = params;

  if (!id) {
    notFound();
  }

  const { data: product } = useQuery({
    queryKey: ["product", +id],
    queryFn: () => ApiCatalog.getProduct(+id),
  });

  return { product };
};
